import React from 'react';
import './HeroSection.css';
import shoe from '../../../images/shoe.jpg'

const HeroSection = () => {
    return (
        <div className="hero-section">
        </div>
    );
};

export default HeroSection;